import React, { useEffect, useState, useContext } from 'react';
import { UIContext } from '../../contexts/UIContext';
import Compressor from 'compressorjs';

import { Button, Paper } from '@mui/material';
import Image from '../Image/Image';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import ImageIcon from '@mui/icons-material/Image';
import LogUtils from '../../utils/LogUtils';

import './CameraCapture.scss';

export function resizeImage(file, maxSize = 800, quality = 0.6) {
  return new Promise((resolve, reject) => {
    const maxFileSize = 1024 * 1024;
    new Compressor(file, {
      quality,
      maxWidth: maxSize,
      maxHeight: maxSize,
      success(result) {
        if (result.size > maxFileSize) {
          resizeImage(file);
        } else {
          resolve(result);
        }
      },
      error(err) {
        reject(err);
      },
    });
  });
}

function CameraCapture({ onImageCapture, setSelectedFile, className, initialImageUrl }) {
  const TAG = "CameraCapture";

  const { showWarningMessage } = useContext(UIContext);

  const [imageUri, setImageUri] = useState(initialImageUrl);

  const logUtils = new LogUtils();

  useEffect(() => {
    if (imageUri) onImageCapture?.(imageUri);
  }, [imageUri, onImageCapture]);

  function handleReset() {
    setImageUri(null);
  }

  async function handleCaptureFromInput(event) {
    try {
      const file = event.target.files[0];
      const optimizedImageFile = await resizeImage(file);

      if (!optimizedImageFile) {
        showWarningMessage({
          message: "Não foi possível acessar o arquivo da foto"
        });
      }

      setSelectedFile(optimizedImageFile);
      setImageUri((window.URL || window.webkitURL).createObjectURL(optimizedImageFile));

    } catch (err) {
      showWarningMessage({
        message: "Não foi possível acessar o arquivo da foto"
      });
      logUtils.logErrorMsg(TAG, 'Failed to handleCaptureFromInput', err);
    }
  }

  return (
    <div className={`camera-capture ${className || ''}`}>
      {
        imageUri ? (
          <Paper elevation={3} className="camera-capture-image" >
            <Image src={imageUri || initialImageUrl} />
            <Button onClick={handleReset} className="camera-capture-button"><CameraAltIcon /></Button>
          </Paper>
        ) : (
          <Paper elevation={3} className="camera-capture-capture">
            <ImageIcon className="failed-capture-image" />
            <Button className="camera-capture-button">
              <CameraAltIcon />
              <input
                id="icon-button-file"
                accept="image/*"
                type="file"
                capture="environment"
                onChange={handleCaptureFromInput} />
            </Button>
          </Paper>
        )
      }
    </div>
  );
}

export default CameraCapture;
